function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.5 3.5H3.5V6.5H6.5V3.5Z",
  fill: "black"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M6.5 13.5H3.5V16.5H6.5V13.5Z",
  fill: "black"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M16.5 13.5H13.5V16.5H16.5V13.5Z",
  fill: "black"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M16.5 3.5H13.5V6.5H16.5V3.5Z",
  fill: "black"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M1 4C1 2.34315 2.34315 1 4 1H8.5V8.5H1V4Z",
  stroke: "black"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M11.5 1H16C17.6569 1 19 2.34315 19 4V8.5H11.5V1Z",
  stroke: "black"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M1 11.5H8.5V19H4C2.34315 19 1 17.6569 1 16V11.5Z",
  stroke: "black"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M19 11.5V16C19 17.6569 17.6569 19 16 19L13.5 19M11.5 19V17M16 11.5L11.5 11.5V14",
  stroke: "black",
  strokeLinecap: "square"
});

var SvgQrCode = function SvgQrCode(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgQrCode, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/qr-code.ebfc5138.svg";
export { ForwardRef as ReactComponent };